import analytics from './analytics';
import campaigns from './campaigns';
import redirect from './redirect';

export default {
  campaigns,
  redirect,
  analytics,
};
